import React from 'react';
import { Link } from 'gatsby';

const HelpCenterBreadCrumb = (props) => {
    return (
        <div className="help-center-breadcrumb">
            <div className="crumb-holder">
                {props.breadCrumb.map((crumb) => (
                    <span key={crumb.name}>
                        <Link to={crumb.link}>{crumb.name}</Link>
                        {crumb.isLast ? '' : ' /'}
                    </span>
                ))}
            </div>
        </div>
    );
};

export default HelpCenterBreadCrumb;
